import styled from '@emotion/styled'
import { useAtomValue } from 'jotai'
import React from 'react'
import { Shapes } from 'src/components/theme'
import { selectedEntityParcel } from 'src/v2/state/map-explorer/search'
import * as coreAtoms from 'src/v2/state/core'
import * as searchAtoms from 'src/v2/state/map-explorer/search'
import {
  SelectedEntityTreeContent,
  SelectedEntityTreeContentSkeleton,
} from 'src/views/map-explorer/sidebar/related-results/selected-entity-tree-content'
import { ErrorBoundary } from 'src/components/errors/error-boundary'

const LoaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${Shapes.spacing[1]}px;
`

const SelectedEntityTreeInner = () => {
  const selectedEntity = useAtomValue(coreAtoms.selectedEntity)
  const parcel = useAtomValue(selectedEntityParcel)
  const nearbyResults = useAtomValue(searchAtoms.selectedEntityNearbyResults)
  const withinParcelResults = useAtomValue(searchAtoms.selectedEntityParcelResults)

  if (!selectedEntity || !parcel) {
    return null
  }

  return (
    <SelectedEntityTreeContent
      parcel={parcel}
      nearbyPlacesResults={nearbyResults}
      selectedEntity={selectedEntity}
      placesWithinParcelResults={withinParcelResults}
    />
  )
}

export const SelectedEntityTree = () => {
  return (
    <ErrorBoundary wrap>
      <React.Suspense
        fallback={
          <LoaderWrapper>
            <SelectedEntityTreeContentSkeleton />
          </LoaderWrapper>
        }>
        <SelectedEntityTreeInner />
      </React.Suspense>
    </ErrorBoundary>
  )
}
